import { render } from "./FontSizeAction.vue?vue&type=template&id=8ddabf12"
import script from "./FontSizeAction.vue?vue&type=script&lang=js"
export * from "./FontSizeAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__